import React, { useState } from 'react';
import { Phone, Menu, X, InstagramIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    t,
    language,
    toggleLanguage
  } = useLanguage();
  const navLinks = [{
    label: t('header.services'),
    href: '#servicios'
  }, {
    label: t('header.protocol'),
    href: '#protocolo'
  }, {
    label: t('header.about'),
    href: '#kate'
  }, {
    label: t('header.reviews'),
    href: '#resenas'
  }, {
    label: t('header.faq'),
    href: '#faq'
  }, {
    label: t('header.giftCard'),
    href: '#gift-card'
  }, {
    label: t('header.contact'),
    href: '#agenda'
  }];
  return <header className="sticky top-0 z-50 w-full bg-brand-dark backdrop-blur-md border-b border-brand-gold/10 md:border-brand-gold/15 shadow-sm md:shadow-lg" data-id="element-250" data-mp="369qnvuv1fdq3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251" data-mp="3fbgkrg7ov4v9">
        <div className="flex justify-between items-center h-16 md:h-20" data-id="element-252" data-mp="3f9ngg7kjswqf">
          {/* Logo Image */}
          <a href="#" className="flex-shrink-0" data-id="element-253" data-mp="2wirrbvix8zup">
            <img src="https://cdn.magicpatterns.com/uploads/d5PCZLxog3stu5Kmdcos9m/tairu_new_1.png" alt="Tairu Aesthetics" className="h-14 w-auto object-contain mix-blend-lighten" data-id="element-254" data-mp="2rlhz6845ea36" />
          </a>

          {/* Contact & CTA */}
          <div className="flex items-center space-x-4" data-id="element-255" data-mp="2hp516y1kla2m">
            <button onClick={toggleLanguage} className="text-xs font-bold tracking-widest text-gray-400 hover:text-brand-gold-light transition-colors flex items-center gap-1" aria-label="Toggle Language" data-id="element-256" data-mp="3fbvk7eobf8o9">
              <span className={language === 'es' ? 'text-brand-gold' : ''} data-id="element-257" data-mp="35kr7klm43zwl">
                ES
              </span>
              <span className="opacity-50" data-id="element-258" data-mp="30loc9svxp81t">|</span>
              <span className={language === 'en' ? 'text-brand-gold' : ''} data-id="element-259" data-mp="1wfq2pa8uexv">
                EN
              </span>
            </button>
            <a href="https://www.instagram.com/tairu.aesthetics/" target="_blank" rel="noopener noreferrer" className="flex lg:hidden items-center text-gray-300 hover:text-brand-gold-light transition-colors" aria-label="Instagram" data-id="element-260" data-mp="3tavccwb1e5p6">
              <InstagramIcon className="w-5 h-5" data-id="element-261" data-mp="1wbuxqod24cjj" />
            </a>
            <a href="tel:5513328938" className="hidden md:flex items-center text-gray-300 hover:text-brand-gold-light transition-colors font-medium text-sm" data-id="element-262" data-mp="1hmqf562co6aw">
              <Phone className="w-4 h-4 mr-2" data-id="element-263" data-mp="18n3c6ftz2sfq" />
              (551) 332-8938
            </a>
            <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex bg-brand-gold hover:bg-brand-gold-light text-white px-6 py-2.5 rounded-sm font-medium transition-colors duration-300 shadow-sm text-sm" data-id="element-264" data-mp="18pg49ltg2j6i">
              {t('header.bookNow')}
            </a>

            {/* Instagram (desktop, next to the hamburger) */}
            <a href="https://www.instagram.com/tairu.aesthetics/" target="_blank" rel="noopener noreferrer" className="hidden lg:flex items-center text-gray-300 hover:text-brand-gold-light transition-colors" aria-label="Instagram" data-id="element-265" data-mp="2t0uaogol62i2">
              <InstagramIcon className="w-5 h-5" data-id="element-266" data-mp="hg3ftyokccb8" />
            </a>

            {/* Menu button */}
            <button onClick={() => setMobileOpen(!mobileOpen)} className="p-2 text-gray-300 hover:text-brand-gold-light transition-colors" aria-label="Abrir menú" aria-expanded={mobileOpen} data-id="element-267" data-mp="w4zmpsevvja9">
              {mobileOpen ? <X className="w-6 h-6" data-id="element-268" data-mp="154mle6g8aazm" /> : <Menu className="w-6 h-6" data-id="element-269" data-mp="153uq6wqjmf9v" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav Dropdown */}
      {mobileOpen && <div className="bg-brand-dark border-t border-brand-gold/10 shadow-lg lg:absolute lg:right-8 lg:top-full lg:w-80 lg:border lg:border-brand-gold/20 lg:rounded-sm lg:shadow-2xl lg:mt-2" data-id="element-270" data-mp="1f324pn90kfyk">
          <nav className="max-w-7xl mx-auto px-4 py-4 space-y-1" data-id="element-271" data-mp="3gup0s37rj11w">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setMobileOpen(false)} className="block py-3 px-4 text-gray-300 hover:text-brand-gold-light hover:bg-white/5 rounded-sm transition-colors font-medium text-sm" data-id="element-272" data-mp="3gwjkxfb7mp4x">
                {link.label}
              </a>)}
            <div className="pt-3 border-t border-brand-gold/10 mt-2" data-id="element-273" data-mp="27w716qdy1g8c">
              <a href="tel:5513328938" className="flex items-center py-3 px-4 text-gray-300 font-medium text-sm" data-id="element-274" data-mp="2cwl7a2vzig3q">
                <Phone className="w-4 h-4 mr-2" data-id="element-275" data-mp="2gx593jri67w7" />
                (551) 332-8938
              </a>
              <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" onClick={() => setMobileOpen(false)} className="block mt-2 text-center bg-brand-gold text-white py-3 rounded-sm font-medium" data-id="element-276" data-mp="1k9gzjq5ibno9">
                {t('header.bookNow')}
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}